import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OtpInitialization } from '../interfaces/otp-initialization.interface';
import { map } from 'rxjs/operators';
import { Response } from '../interfaces/response.interface';
import { ApiUrlService } from './api-url.service';

@Injectable()
export class OtpService {
  private _url = `${this._apiService.apiUrl}/access/otp`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public getOtpInitializationData(): Observable<OtpInitialization> {
    return this._http.get<Response<OtpInitialization>>(this._url)
      .pipe(
        map(response => response.data),
      );
  }

  public validateCode(code: string): Observable<any> {
    return this._http.post(`${this._url}/validate`, { code });
  }

  public disable2FA(code: string): Observable<any> {
    return this._http.delete(`${this._url}`, { body: { code } });
  }
}